module.exports = __webpack_public_path__ + "img/f130bac4e8f99dcc8493ac0e500514f7.png";